import React from 'react';

import Advantage from './Advantage';
import Team from './Team';
import StudyInWukong from './StudyInWukong';
import Specialty from './Specialty';

import styles from './style.module.scss';

const Math = () => {
  return (
    <div className={styles.container}>
      {/* 数学特色 */}
      <Specialty />

      {/* 悟空核心优势 */}
      <Advantage />

      {/* 在悟空学习 */}
      <StudyInWukong />

      {/* 教师团队 */}
      <Team />
    </div>
  );
};

export default Math;
